import React from 'react';
import {useDispatch} from 'react-redux';
import Navbar from './NavBar';
import {BASE_URL, DYSLEXIA, DISABILITY} from '../constants';
import { Header, Footer } from 'components';
import { bntImg } from '../images';

export const Home = ()=> {

  const dispatch = useDispatch();

  const redirectToNIAS = () => {
    document.location.href = `${BASE_URL}/nias`;
  }

  const handleVisionImapired = (isImpaired) => {
    dispatch({
        type:DISABILITY,
        payload: isImpaired,
    })
  }

  const handleDyslexia = (isDyslexic) => {
    dispatch({
        type:DYSLEXIA,
        payload: isDyslexic,
    })
  }

  return (
  <>
    <div className="grid-container">
      <div>
        <Navbar
          logoutUrl= {`${BASE_URL}/nias/application/logout`}
          loginUrl={`${BASE_URL}/nias`}
          handleVisionImpaired={handleVisionImapired}
          handleDyslexia={handleDyslexia}
          test
        />
        <Header/>
      </div>
      <div className="wrapper">
        <div className="text-center main-content">
          <div className="welcomeText text-impaired">
            <h2>Dobro došli u Sustav e-Pristojbe</h2>
            <p>Sustav e-Pristojbe je središnji informacijsko-tehnološki sustav koji omogućuje izračun i <br/>plaćanje iznosa pristojbe i/ili naknade za pismena i radnje pred javnopravnim tijelima.</p>
            <p>Za pristup sustavu, prijavite se putem NIAS-a.</p>
          </div>
            <div className="niasBtnWrapper">
              <button onClick={redirectToNIAS} className="niasLoginBtn">
                <img alt="Prijava" className="niasBtnImg" src={`${bntImg}`}/> Prijava
              </button>
            </div>
        </div>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  </>
  )
}
